import Icon from "../icon";
import { Input } from "ui/components/input";
import { SEARCH } from "icons";
import { cn } from "utils";
import { useSearchParams, useNavigate, useLocation } from "react-router-dom";
import { useEffect, useRef } from "react";

export default function ListSearch({
  search,
  setSearch,
  fluid = false,
  searchPlaceholder,
  clearFiltersOnSearch = false, // New prop to control filter clearing
  clearFilters, // Function to clear filters if needed
}) {
  const [searchParams, setSearchParams] = useSearchParams();
  const querySearch = searchParams.get("search");
  const queryFilters = searchParams.get("filters");

  useEffect(() => {
    if (querySearch || querySearch === "") {
      setSearch(querySearch);
      const newParams = new URLSearchParams(searchParams);
      newParams.delete("search");
      setSearchParams(newParams, { replace: true });
    }
  }, [querySearch, setSearch]);

  return (
    <div className={cn("relative", fluid ? "w-full" : "w-80")}>
      <Icon
        icon={SEARCH}
        className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground"
      />
      <Input
        type="text"
        value={search}
        onChange={(e) => {
          setSearch(e.target.value);
        }}
        placeholder={searchPlaceholder}
        className="pl-9 h-10 !w-full"
      />
    </div>
  );
}
